import { type ApiEndpoints } from '@/legacy-src/services/api'

import Toaster from '../../../utilities/toaster'

export const verifyEmployeeCode = async (
  api: ApiEndpoints,
  code: string,
  slug: string,
): Promise<{ token: string; path: string } | null> => {
  try {
    const savedRes = await api.verifyEmployeeCode(slug, code)

    if (savedRes.data.type === 'ALREADY_EXISTS') {
      Toaster.error('component.toaster.employeeAlreadyExists')
    } else {
      Toaster.success('component.toaster.employeeCodeValid')
    }
    return { token: savedRes.data.token, path: savedRes.data.path }
  } catch (e: any) {
    if (e.data.type === 'BAD_REQUEST' || e.data.type === 'INVALID_CODE') {
      Toaster.error('component.toaster.employeeCodeInvalid')
    }
    return null
  }
}
